// Vocabulary API client. All writes go through the org_router so the backend
// permission check (`org.settings.update`) is enforced.

const API = '/api/org';

async function jfetch(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    credentials: 'include',
    ...options,
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      detail = j.detail || JSON.stringify(j);
    } catch { /* ignore */ }
    const err = new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export const vocabApi = {
  // Fetch all 4 vocabularies in a single call.
  listAll: () => jfetch('/vocabulary'),
  // Fetch one vocabulary kind: intent|priority|effort|status
  list: (kind) => jfetch(`/vocabulary/${kind}`),
  // Update a single row. updates = { color, intent_key, ... }
  update: (kind, key, updates) =>
    jfetch(`/vocabulary/${kind}/${encodeURIComponent(key)}`, {
      method: 'PUT',
      body: JSON.stringify(updates),
    }),
  // Wipe + re-seed defaults for a whole kind.
  restoreDefaults: (kind) =>
    jfetch(`/vocabulary/${kind}/restore-defaults`, { method: 'POST' }),
};

export default vocabApi;
